import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { get } from 'lodash';
import { Text } from 'office-ui-fabric-react/lib/Text';
import Module from '../../components/Module';
import ModuleHeader from '../../components/ModuleHeader/ModuleHeader';
import ModuleContentList from '../../components/ModuleContentList';
import { fetchDimensionListDetails } from '../../actions/dimensionList';
import { fetchProduct } from '../../actions/products';
import { capitalizeWordsInString } from '../../utils';
import styles from './AddDimensionListDetails.style';
import DimensionListsDetails from '../../components/DimensionListsDetails';

const AddDimensionListDetails = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { listFormData } = useLocation();
  const [listType, setListType] = useState('');
  const [lists, setLists] = useState([]);
  const [allListIds, setAllListIds] = useState([]);
  const [items, setItems] = useState([]);
  const [itemsWithProductIds, setItemsWithProductIds] = useState([]);
  const dimensionLists = useSelector(state => get(state, `entities.dimensionListDetails`));
  const products = useSelector(state => get(state, `entities.products`));

  const listsWithItems = dimensionLists
    ? Object.values(dimensionLists)
        .filter(item => allListIds.includes(item.listId))
        .reduce((arr, list) => {
          const listItemsWithUpdatedHierarchy = list.listItems.map(item => {
            return { ...item, listHierarchy: [{ [list.listId]: list.listName }] };
          });
          return arr.concat(
            listItemsWithUpdatedHierarchy.filter(item => {
              const index = arr.findIndex(i => i.name === item.name);
              if (index !== -1) arr[index].listHierarchy.push({ [list.listId]: list.listName });
              return index === -1;
            }),
          );
        }, [])
    : [];

  const mergedItems = listsWithItems.concat(
    (listType === 'product' ? itemsWithProductIds : items).filter(item => {
      const index = listsWithItems.findIndex(i => i.name === item.name);
      if (index !== -1)
        listsWithItems[index].listHierarchy.push({
          0: listFormData?.listName || 'Directly Added to List',
        });
      // eslint-disable-next-line no-param-reassign
      else item.listHierarchy = [{ 0: listFormData?.listName || 'Directly Added to List' }];
      return index === -1;
    }),
  );

  useEffect(() => {
    // on reload page, send user back to overview page
    if (!listFormData)
      history.push({
        pathname: '/dimensionLists/add',
      });
    else {
      setListType(
        listFormData.listType === 'productTypeId' ? 'productType' : listFormData.listType,
      );
      const { listItems } = listFormData;
      const seperatedListItems = listItems.reduce(
        (obj, item) => {
          if (item.isList) obj.lists.push(item);
          else obj.items.push(item);
          return obj;
        },
        { lists: [], items: [] },
      );
      setLists(seperatedListItems.lists);
      setItems(seperatedListItems.items);
    }
  }, [listFormData]);

  useEffect(() => {
    const ids = lists.map(list => {
      dispatch(fetchDimensionListDetails(list.id, { useCache: false }));
      return list.id;
    });
    setAllListIds(ids);
  }, [lists]);

  useEffect(() => {
    if (listType === 'product' && items.length > 0) {
      items.map(item => dispatch(fetchProduct(item.id)));
    }
  }, [items]);

  useEffect(() => {
    try {
      const obj = items.map(item => {
        const idString = parseInt(item.id, 10);
        const { productIds } = products[idString].metadata;
        return { ...item, productIds };
      });
      setItemsWithProductIds(obj);
    } catch (err) {
      setItemsWithProductIds(itemsWithProductIds);
    }
  }, [products]);

  return (
    <>
      {mergedItems.length === 0 && (
        <ModuleHeader>
          <div className={styles.resultsMessage}>
            <Text as="h4" block>
              No {capitalizeWordsInString(listType)} List Items Added
            </Text>
          </div>
        </ModuleHeader>
      )}
      {mergedItems.length > 0 && (
        <>
          <ModuleHeader>
            <div className={styles.resultsMessage}>
              <Text as="h4" block>
                {mergedItems.length} {capitalizeWordsInString(listType)} List Item
                {mergedItems.length > 1 ? 's' : ''}
              </Text>
            </div>
          </ModuleHeader>
          <Module>
            <ModuleContentList>
              <DimensionListsDetails
                listName="addListDetails"
                dimensionItems={mergedItems}
                listType={listType}
                shimmered
                className={styles.scrollablePane}
                multiLine
              />
            </ModuleContentList>
          </Module>
        </>
      )}
    </>
  );
};

export default AddDimensionListDetails;
